import { gql } from '@apollo/client';
import { TASK_FORM_ITEM_FRAGMENT } from '../../../common/form/task-form/model/task-items.gql';

export const GET_ALL_APPLICANT_TASKS = gql`
  query GetAllApplicantTasks($userId: String!) {
    vm {
      application(userId: $userId) {
        applicationId
        currentStageId
        completedStageIds
        relevantTasks {
          ...SUYPOverviewTasksListTask
        }
        applicationActivities {
          applicationActivityId
        }
        applicationRoles {
          applicationRoleId
          status
        }
        funnel {
          funnelId
          lockPrograms
          lockActivities
          lockRoles
          programs {
            programId
          }
          activities {
            activityId
          }
          activityRoles {
            activityRoleId
          }
        }
      }
      profile(userId: $userId) {
        profileId
        preferredName
        simpleAvailability {
          simpleAvailabilityId
        }
        completedTasks {
          completedTaskId
          task {
            taskId
          }
          dateLastUpdated
          dateRevoked
          status
          refereeContacts {
            dateInvited
          }
        }
      }
    }
  }

  fragment SUYPOverviewTasksListTask on VOLUNTEER_ApplicantTaskType {
    taskId
    title
    description
    order
    adminOnly
    isRefereeCheckTask
    isEventTask
    blocksProgress
    cake {
      description
      cakeType
    }
    stage {
      taskStageId
      name
      order
      automateApproval
    }
    automateApproval
    dateRemoved
  }
`;

export const GET_APPLICANT_VOLUNTEER_PROFILE = gql`
  query GetApplicantVolunteerProfile($userId: String!) {
    vm {
      preApplicationContent {
        preApplicationContentId
        content
        videoUrl
        isEnabled
      }
      profileReceivedContent {
        profileReceivedContentId
        content
        isEnabled
      }
      application(userId: $userId) {
        funnel {
          funnelId
          lockPrograms
          lockActivities
          lockRoles
          programs {
            programId
          }
          activities {
            activityId
          }
          activityRoles {
            activityRoleId
          }
        }
      }
      allowMultiProgramApplication: configItem(key: "allow-multi-program-application") {
        configItemId
        defaultValue
        configItemValue {
          flagValue
        }
      }
      programs {
        programId
        name
        description
        dateSuspended
        displayOrder
        programGroup {
          programGroupId
          name
          displayOrder
        }
      }
      profileTask {
        taskId
        title
        description
        order
        taskItems {
          ...TaskFormItem
        }
      }
      profile(userId: $userId) {
        profileId
        firstName
        lastName
        preferredName
        email
        contactNumber
        dateOfBirth
        dateLastUpdated
        avatarUrl
        completedTasks {
          completedTaskId
        }
        completedProfileTask {
          completedTaskId
        }
        programs {
          programId
        }
        isCompleted
        isProfileTaskApproved
        percentageComplete
      }
    }
  }

  ${TASK_FORM_ITEM_FRAGMENT}
`;
